import { UpdateFinderInformation } from './models/chatbotmessage';
import { DataService } from 'src/app/services/chat/data.service';
import { SocketService, OtherIncommingMessage, RoomMessage, User } from './services/socket/socket.service';

import { Component ,OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PathLocationStrategy } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import {  first } from 'rxjs/operators';
import { AuthService } from './services/auth/auth.service';
import { OneSignal } from 'onesignal-ngx';
import { NotificationService } from './services/notification.service';


class Login{
  error;
  message;
  tag_info:{tag_info:{emergency : string ;}}
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'projectfoundme';
  routePathParam;
  navigationEnd:Observable<any>;
  subRoutePathParam ;
  supportLanguages = ['en', 'fr'];
  SerialNumberInput: string ;
  login = new Login();
  data:any;
  pathParam :Observable<string>;
  userId:any;
  onsSignalKeyMobile: string = '';
  onsSignalKeyFinder: string = '';
  idDevice: string = null;

  constructor(private activatedRoute: ActivatedRoute,   private authService :AuthService,
    private translateService: TranslateService,private router: Router,
     pathLocationStrategy: PathLocationStrategy,private translate : TranslateService,
     private socketService: SocketService, private oneSignal: OneSignal,    private notificationService: NotificationService
    ) {
    //chmod('/src/OneSignalSDKWorker.js', 777, null);
    translate.setDefaultLang('en');
    const browserlang = this.translateService.getBrowserLang();
    localStorage.setItem('browsercode',browserlang)
    this.translateService.addLangs(this.supportLanguages);
   // this.translateService.setDefaultLang('en');
      this.authService.getTranslationId(browserlang).subscribe((data) => {
        localStorage.setItem("languageId",data.id_language);

        this.translateService.use(data.id_language);
        //this.translateService.getTranslation(data.id_language);
      },
      (err) => {
        this.translateService.use('en');
        this.translateService.getTranslation('en');
      });

      this.socketService.onServerEvent().subscribe((data) => {
        //console.log(data as OtherIncommingMessage);
      });

     /*  this.socketService.onMessageEvent().subscribe((data) => {
        const messageContent = JSON.parse(data as string)
        this.socketService.newMessageSent(messageContent);
        this.socketService.newMessageEmergencySent(messageContent);
      }); */

      this.socketService.onRoomUsersEvent().subscribe((data) => {
        const event = JSON.parse(data as string) as RoomMessage;
        const users = event.message.map((user) => JSON.parse(user)) as User[];
        const newEvent = Object.assign({}, event, { message: users });
        //console.log(newEvent);
      });
      this.socketService.onRoomEvent().subscribe((data) => {
        //this.socketService.eventRoom(JSON.parse(data as string));
      });
      this.socketService.onErrorEvent().subscribe((data) => {
        //console.log(data as OtherIncommingMessage);
      });

  // Écouter les messages WebSocket pour les notifications
  this.socketService.onMessageEvent().subscribe((data) => {
    const messageContent = JSON.parse(data as string);
    
    // Afficher une notification pour les nouveaux messages
    if (messageContent && messageContent.message) {
      const senderName = messageContent.user?.name || 'FoundMe Finder';
      const messageText = messageContent.message.length > 50 
        ? messageContent.message.substring(0, 50) + '...' 
        : messageContent.message;
      
      this.notificationService.showLocalNotification(
        senderName,
        messageText
      );
    }
    
    // Existing socket message handling
    this.socketService.newMessageSent(messageContent);
    this.socketService.newMessageEmergencySent(messageContent);
  });

  }
  ngOnInit(): void  {

    this.authService.getParamApp().subscribe((response) => {
      this.onsSignalKeyMobile = response.data['onesignal_appid'];

      this.onsSignalKeyFinder = response.data['onesignal_web_app_id'];

      
      this.oneSignal.init({
        appId: this.onsSignalKeyFinder,
        allowLocalhostAsSecureOrigin: true,
      });
      
      setTimeout(() => {
        this.oneSignal.getUserId().then((idDevice: string | null) => {
          
          this.idDevice = idDevice;
      
          if (!idDevice) {
          
            
            // Demander aussi la permission pour les notifications locales
            this.notificationService.requestPermission().then((granted) => {
          
            });
            
            this.oneSignal.isPushNotificationsEnabled().then((isEnabled: boolean) => {
 
              if (!isEnabled) {
                this.oneSignal.showSlidedownPrompt();
              }
            });
      
          } else {
            localStorage.setItem('idDevice', this.idDevice);
            
            // Demander la permission pour les notifications locales même si OneSignal fonctionne
            this.notificationService.requestPermission();
          }
        }).catch((error: any) => {
          console.error('OneSignal Error:', error);
        });
      }, 1000);
    });
  }
  


  navigate() {
    if (this.SerialNumberInput)
    {

        this.authService.login(this.SerialNumberInput, this.idDevice).pipe(first())

        .subscribe((data :Login)=>{
            this.login = data;

            if(this.login.error=== true)
          {
            //alert(this.login.message)
          }
          else if ( data.tag_info!= null)
              if (data.tag_info.tag_info != null )
                  if (data.tag_info.tag_info.emergency != "1"  )
                  this.router.navigate(['/chathome']);
                  else
                  this.router.navigate(['/lost_or_found']);
                }
      )
   }
  }



}
